import { render, staticRenderFns } from "./Pesquisar.vue?vue&type=template&id=076c22d3&"
import script from "./Pesquisar.vue?vue&type=script&lang=js&"
export * from "./Pesquisar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports